import React, {useEffect} from 'react';
import NoticiasCompletas from '../NoticiaCompleta/index'
import CFDI from './ImagenesMuestra/CFDI.png';
import CFDI2 from './ImagenesMuestra/CFDI2.png'



export default function NoticiaBeneficiosCFDI(props){
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(<>
    <NoticiasCompletas
    encabezado={'Beneficios de las modificaciones al CFDI 4.0'}
    categoria={'Facturación electrónica'}
    fecha={'ENERO 2022'}
    texto={'Cabe apuntar el desglose de las modificaciones que traen consigo y que serán efectivas desde el arranque de 2022. Así como los cambios a la factura electrónica no solamente implican la emisión de CFDI, que pasan de la versión 3.3 a la 4.0, sino que se realizarán también ajustes a dos documentos complementarios: el CFDI de retenciones e información de pagos y el Complemento de recepción de pagos. Las medidas adoptadas, de acuerdo con el SAT, tienen el objetivo de responder a la Miscelánea Fiscal. Asimismo, se busca robustecer el timbrado electrónico y los servicios agregados. Para la autoridad tributaria, se incrementará la calidad de la información recibida por parte de los contribuyentes a través de sus CFDI emitidos. Esto se traduce en que brindará un mayor control en la determinación de impuestos basados en el flujo de efectivo, como el IVA. Por lo tanto, uno de los beneficios del CFDI 4.0 es que facilitará las declaraciones sobre las transacciones que se realizan de manera diferida, ya que permitirá identificar la factura original de la cual proviene la operación. En contraparte, los contribuyentes se benefician al agilizarse sus declaraciones con información prellenada. Además, podrán recibir mejores servicios del SAT.'}
    portada={CFDI2}
    interes1={CFDI}
    link1={'/noticiaCFDI'}
    tituloInteres1={'CFDI 4.0'}
    />
    </>)
}